<template>
  <NuxtLayout>
    <div class="prose flex flex-col w-screen h-screen items-center justify-center">
      <template v-if="error.statusCode === 404">
        <Error404 />
      </template>
    </div>
  </NuxtLayout>
</template>

<script setup>
// TODO: implement generic error componenet, but first I need to find an error to test it with
const error = useError()
</script>
